import miseAJourRepartitionTva from '@/services/devisCommandes/calcul/miseAJourRepartitionTva';
import * as devisConf from '@/configuration/devisConf';
import calculTva from '@/services/devisCommandes/calcul/calculTva';

export default function calculRepartitionTva(devisCommande, listeLignesCommande) {
  if (!devisCommande) {
    return;
  }
  devisCommande.repartitionsTva = [];
  if (listeLignesCommande) {
    listeLignesCommande.forEach((ligneCommande) => {
      if (ligneCommande.type !== devisConf.NORMAL) return;
      miseAJourRepartitionTva(ligneCommande, devisCommande);
    });
  }
  calculTva(devisCommande);
}
